var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"dialog-footer"},[_c('ElButton',{attrs:{"type":"text"},on:{"click":_vm.handleCancel}},[_vm._v("取消")]),_c('ElButton',{attrs:{"type":"primary"},on:{"click":_vm.handleComfirm}},[_vm._v("查看进度")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-body"},[_c('div',[_vm._v("1.文件正在导出，请跳转至【导出记录】查看进度和下载文件")]),_c('div',[_vm._v("2.关闭此弹窗不影响文件生成")])])
}]

export { render, staticRenderFns }